import { createAsyncThunk } from "@reduxjs/toolkit";
import vocManaApi from 'api/vocManaApi';
import { formatQueryParams } from "helpers/format";
import 'react-toastify/dist/ReactToastify.css';

export const getVOCList = createAsyncThunk("VOCList", async (params: any = {}) => {
  try {
    const response = await vocManaApi.vocList(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

